<template>
    <div id="contenedro-principal-convocatorias" class="container-fluid p-0">
        <div class="titulo-contenedor">
            <h3 v-if="opciones.conTitulo.mostrar" :style="opciones.estilosCss">{{ opciones.conTitulo.texto }}</h3>
        </div>
        <CNoSeEncontraronResultados v-if="!this.campoRequeridoEsValido(convocatorias)" :opciones="{ tituloBusqueda: 'Búsqueda en convocatorias', NombreSeccion: 'Convocatorias' }"></CNoSeEncontraronResultados>
        <div v-if="this.campoRequeridoEsValido(convocatorias)" id="seccion-convocatorias">
            <div v-for="(convocatoria,index) in convocatorias" :key="'ce' + index" class="convocatoria form-inline">
                <h5 class="mr-2" @click="accesoAContenido({ rutaDeDescarga: convocatoria.esDescarga, ruta: convocatoria.RutaDeAcceso })"><i class="fas fa-download"></i>&nbsp;&nbsp;{{ convocatoria.Nombre }}</h5>
                <h6>- {{ convocatoria.Descripcion }}</h6>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/../static/js/api'
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'

export default {
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        convocatorias: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                conTitulo: { mostrar: false, texto: 'Titulo', estilosCss: '' }
            })
        },
    },
    components: {
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    data() {
        return {
            
        }
    },
    methods: {
        accesoAContenido: function({ rutaDeDescarga, ruta }) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (!rutaDeDescarga) ? "_blank" : '';
            a.href = (rutaDeDescarga) ? `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ ruta }` : ruta;
            a.click();
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    created() {
        
    },
    computed: {
        obtenrUrlArea() {
            return this.$route.path;
        }
    }
}
</script>
<style scoped>
#contenedro-principal-convocatorias {
    padding-top: 6vmin !important;
    padding-bottom: 10vmin !important;
}

.titulo-contenedor {
    border: 1px solid #A4A0A0;
    color: white;
    background-color: rgb(59, 59, 59);
    padding: 5px 10px 0px 25px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

#seccion-convocatorias {
    border: 1px solid #A4A0A0;
    border-top: none;
    padding: 1em 1em 1em 1.5em;
}

.convocatoria {
    color: black;
}

.convocatoria:hover, .convocatoria:focus {
    color: #be9a5e;
}

.convocatoria h5 {
    font-size: 2.4vmin;
    font-weight: bold;
    cursor: pointer;
}

.convocatoria h6 {
    font-size: 1.8vmin;
    color: #676666;
}

.titulo-contenedor h3 {
    font-weight: bold;
    font-size: 3.5vmin;
}

.espacio {
    padding: 5vmin 16vmin 5vmin 16vmin;
}

.espacio-superior {
    padding-top: 2em;
}

.espacio-inferior {
    padding-top: 2em;
}

.espacio-derecho {
    padding-top: 2em;
}

.espacio-izquierdo {
    padding-top: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CContenedorConvocatorias.vue